import React, { useState } from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import { ButtonIcon, OutlinedButton } from '@prisjakt/ui/button/variants';
import { SizeVariantsButtonLabel } from './size-variants-button-label';
import { SizeVariantsGrid } from './size-variants-grid';
import { IVariantsProps } from './types';
import { getSizeTitle } from './utils';
import { Modal } from './styles';
import { IconDropdownDown, IconDropdownUp } from '@prisjakt/ui/icon';

export const SizeVariantsMobileVersion: React.FC<IVariantsProps> = props => {
  const { t, market } = useAppContext();
  const [visible, setVisible] = useState<boolean>(false);
  const closeHandler = () => setVisible(false);
  const toggleHandler = () => setVisible(!visible);

  return (
    <>
      <OutlinedButton onClick={toggleHandler} fullWidth>
        <SizeVariantsButtonLabel />
        <ButtonIcon>
          {visible ? <IconDropdownUp /> : <IconDropdownDown />}
        </ButtonIcon>
      </OutlinedButton>

      {visible && (
        <Modal
          isOpen
          onRequestClose={closeHandler}
          shouldShowCloseIcon
          width="inherit"
        >
          <SizeVariantsGrid {...props} title={getSizeTitle(t, market)} />
        </Modal>
      )}
    </>
  );
};
